module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//5.jpg?29d228bfa5bcc2ad0d738a586e83f02b";